/*
 * @Author: gaoqiaoning gao201203
 * @Date: 2024-01-17 16:36:48
 * @LastEditors: gaoqiaoning gao201203
 * @LastEditTime: 2024-01-19 14:49:16
 * @FilePath: \yayi-chat-front\common\hooks\useEventSource.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 从 storage 模块导入 Session 工具
import { Local, Session } from '/@common/utils/storage';
// 从 Microsoft 库导入 fetchEventSource 函数
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { useUserInfo } from '/@/stores/userInfo';
import {useChatStore} from '/@/stores/chat';
import { Modal } from 'winbox-ui-next';
import { h } from 'vue';
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
import { modelVersion } from "/@common/utils/model";
import { storeToRefs } from 'pinia';
import { useThemeConfig } from '/@/stores/themeConfig';
import { getGuestId,getTicketId } from "/@common/utils/utils.ts"
import DSBridge from '/@common/utils/dsBridge/dsBridge'; 
import { Message } from 'winbox-ui-next';
const { isMobile } = useBasicLayout();
const storesThemeConfig = useThemeConfig();
const { themeConfig } = storeToRefs(storesThemeConfig);

export class RetriableError extends Error {
  constructor(message, status, statusText) {
    super(message)
    this.name = 'RetriableError'
    this.status = status
    this.statusText = statusText
  }
}
export class RetriableJsonError extends Error {
  constructor(message, content) {
    super(message)
    this.name = 'RetriableJsonError'
    this.content = content
  }
}
export class FatalError extends Error {
  constructor(message) {
    super(message)
    this.name = 'FatalError'
  }
}
export async function useEventSource(url: string, params = {}, abortController: any, onmessage?, onclose?, onerror?) {
  // 使用给定的 URL 和选项创建一个 EventSource 对
  let Platform=isMobile.value ? 'h5':'pc';
  if(DSBridge.isDSBridgeEnvironment()){
        Platform='app'
      }
  const hearParams=getTicketId()?{
    "Content-Type": 'application/json',
    'GuestId': getGuestId(),// 使用 Session 存储中的 token 进行授权
    'Ticket':getTicketId(),
    'Model-Version':isMobile.value ? modelVersion : params.modelVersion,
    'I18n': themeConfig.value.globalI18n,
    'Platform': Platform,
  }:{
      "Content-Type": 'application/json',
      'Authorization': `${Session.get('token')}`,// 使用 Session 存储中的 token 进行授权
      'Model-Version': isMobile.value ? modelVersion : params.modelVersion,
      'I18n': themeConfig.value.globalI18n,
      'Platform': Platform,
  }
  const source = await fetchEventSource(url, {
    method: 'POST',
    headers: hearParams,
    body: JSON.stringify(params),
    // 使用 abort signal 在需要时取消请求
    signal: abortController.signal,
    // 即使页面隐藏也打开连接
    openWhenHidden: true,
    // 定义不同事件的回调函数
    onopen(event) {
      const stores = useUserInfo();
      const chatStore = useChatStore();
      if(event.status == 401){
        if(DSBridge.isDSBridgeEnvironment()){
          Message.clear()
          Message.info({
            id: 'logoutMessageInfo',
            content:'登录已过期',
        })
				  return
        }
        stores.userInfos.isLoginExpired = true
      }
      if(event.status == 429){
        Modal.open({
          title: () => {
            return h('div',{class: 'title'}, [
              h('h2',{class: 'title-text'},'YAYI 2.0每日'),
              h('h2',{class: 'title-span'},'限量300次')
            ]);
          },
          content: () => {
            return h('div', [
              h('p',{class: 'detail-text'},'今日你的操作已超过300次，'),
              // h('p',{class: 'detail-text'},'如需继续使用请切回YAYI1.0版本'),
              h('span',{class: 'detail-span'},'若有更多需求，可拨打 400-093-5566 联系客服')
            ]);
          },
          maskClosable: false,
          // okText: '使用YAYI 1.0',
          modalClass: 'modelVersionModal',
          width: '420px',
          // onOk: () => {
          //   Local.set('modelVersion', 'YAYI-V1-13B-8K')
          //   chatStore.newBuilt()
          // },
        });
      }


      // 创建回调
    },
    onmessage(event) {
      // 消息回调
      onmessage?.(event.data)
    },
    onclose() {
      // 结束回调
      onclose?.()
      // 当发生错误时，中止请求
      abortController.abort();
    },
    onerror(e) {
      
       // 失败回调
      onerror?.(e)
      // 当发生错误时，中止请求
      abortController.abort();
    }
  })

  return {
    close: () => {
      abortController.abort();
      source?.close();
    },
  };
}
